import styled from '@emotion/styled';
import { DSButton, DSContextMenu } from '@hundred5/design-system';
import React from 'react';

interface DeleteConfirmationContextMenuProps {
  open: boolean;
  title: string;
  message: string;
  deleteButtonText: string;
  onClick: () => void;
  onClose: () => void;
  position?: { top?: string; right?: string; bottom?: string; left?: string };
}

export function DeleteConfirmationContextMenu({
  open,
  title,
  message,
  onClick,
  onClose,
  deleteButtonText,
  position = { top: '-168px', right: '0' },
}: DeleteConfirmationContextMenuProps) {
  return (
    <DSContextMenu open={open} position={position}>
      <ConfirmDeleteContainer>
        <ConfirmDeleteTitle>{title}</ConfirmDeleteTitle>
        <ConfirmDeleteDescription>{message}</ConfirmDeleteDescription>
        <ButtonContainer>
          <DSButton
            variant="secondary"
            size="small"
            onClick={() => {
              onClose();
            }}
          >
            Cancel
          </DSButton>
          <DSButton
            size="small"
            variant="destructive-primary"
            onClick={onClick}
          >
            {deleteButtonText}
          </DSButton>
        </ButtonContainer>
      </ConfirmDeleteContainer>
    </DSContextMenu>
  );
}

const ConfirmDeleteContainer = styled.div`
  padding: 16px;
  width: 298px;
`;

const ConfirmDeleteTitle = styled.div`
  color: ${(props) => props.theme.colors.purple[100]};
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 16px;
`;

const ConfirmDeleteDescription = styled.div`
  color: ${(props) => props.theme.colors.purple[100]};
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 16px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 8px;
`;
